import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private readonly isProduction = environment.production;

  debug(...args: unknown[]): void {
    if (!this.isProduction) console.log(...args);
  }

  info(...args: unknown[]): void {
    if (!this.isProduction) console.info(...args);
  }

  warn(...args: unknown[]): void {
    if (!this.isProduction) console.warn(...args);
  }

  error(...args: unknown[]): void {
    if (!this.isProduction) console.error(...args);
    // En producción los errores se enviarán a un servicio de monitoreo (Sentry, Datadog, etc.)
  }
}
